/* eslint-disable max-len */
/* THIS IS GENERATED BY generateBlockMaps.js - PLEASE DO NOT EDIT */
import {
    ProductListChequing,
} from '@ratehub/web-components';


const BLOCK_TO_COMPONENT_MAP = {
    [ProductListChequing.blockKey]: { render: ProductListChequing },
};

export default BLOCK_TO_COMPONENT_MAP;
